import { gql } from "@apollo/client";

export const GET_STORE_CONFIG = gql`
  query getStoreLogo {
    storeConfig {
      default_title
      default_robots
      gtm_headscript
      gtm_bodyscript
      default_description
      store_code
      header_logo_src
      logo_alt
      base_media_url
      homepage_main_header
      homepage_sub_header
      attorney_enable
      number_of_attorney
      attorney_label
      attorney_tooltip_info
      trial_duration
      trial_tooltip
      trial_message_summarycard
      trial_message_paymentcard
      subscription_type
      default_subscription_type
      subscribe_now_button_text
      price_suffix_monthly
      price_suffix_yearly
      checkout_terms_and_condition
      tax_disclaimer_message
      etax_api_error_label_order_summary
      etax_api_error_label_email_order_success
      contact_us_url
      contract_length_type
      contract_length_options_monthly
      contract_length_options_monthly_default
      contract_length_options_yearly
      contract_length_options_yearly_default
      address_validation_api_url
      address_validation_api_enabled
      telligent_api_enabled
      telligent_api_url
      telligent_products_json
      __typename
    }
  }
`;

export const GET_PAYMENT_FREQUENCY_CONFIG = gql`
  query getPaymentFrequencyConfig {
    storeConfig {
      contract_length_is_dynamic
      subscribe_now_button_text
      price_suffix_monthly
      price_suffix_yearly
      subscription_label
      contract_details_json
      discount_details_json
    }
  }
`;